import React, { ReactNode, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { OVERLAYS_MAP, OVERLAY_KEYS } from '../../constants';
import { OverlayState } from '../../recoil/overlay/overlay.state';
import Button from '../button/v2/button';
import Container from '../containers/container';
import { VStack } from '../layouts/stack.layout';

type Props = {
  children?: ReactNode;
  className?: string;
  overlays: OVERLAYS_MAP;
};

type SCProps = {
  children?: any;
  name: OVERLAY_KEYS;
};

const styles = {
  container:
    'tablet-lg:hidden z-[130] fixed top-0 left-0 w-screen h-screen bg-white/[15%] backdrop-blur-sm',
  overlay: 'z-[140] absolute top-0 left-0 w-full h-full',
  wrapper: 'items-center w-full h-full',
  'modal-container':
    'absolute bottom-0 mobile:w-full mobile:min-h-[250px] z-[150] overflow-auto bg-[#08080D] rounded-t-3xl',
};

function OverlayController(props: Props) {
  const [overlay, setOverlay] = useRecoilState(OverlayState);
  const { children } = props;

  const closeModal = () => {
    setOverlay((prev) => ({ ...prev, current: null, shouldShow: false }));
  };

  useEffect(() => {
    overlay.shouldShow
      ? document.querySelector('body')?.classList.add('no-scroll')
      : document.querySelector('body')?.classList.remove('no-scroll');
  });

  const Modals = React.Children.map(children, (child: any) =>
    child.type.displayName === 'Overlay' ? (
      <>
        {overlay.current === child.props.name && <Container>{child}</Container>}
      </>
    ) : null
  );

  return (
    <>
      {overlay.shouldShow && (
        <Container extensions={styles.container}>
          <Container onClick={closeModal} extensions={styles.overlay} />
          <Container extensions={styles['modal-container']}>
            <VStack extensions="h-full justify-between pt-[20px]">
              <Container extensions="w-full">{Modals}</Container>
              <Container extensions={'w-full px-2 pb-2 pt-7'}>
                <Button
                  size="base"
                  width="full"
                  variant="outline"
                  color="danger"
                  onClick={closeModal}
                >
                  Close
                </Button>
              </Container>
            </VStack>
          </Container>
        </Container>
      )}
    </>
  );
}

const Overlay = (props: SCProps) => props.children;
Overlay.displayName = 'Overlay';

OverlayController.Overlay = Overlay;

export default OverlayController;
